import { FC } from "react";

import CreateInviteForm from "./OrganizationSettings/CreateInviteForm";

import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { useUser } from "@/context/user-context";

interface AddWorkspaceMemberProps {
  setOpen: (isOpen: boolean) => void;
  isOpen: boolean;
}

const AddWorkspaceMemberModal: FC<AddWorkspaceMemberProps> = ({ setOpen, isOpen }) => {
  const userContext = useUser();

  return (
    <Dialog open={isOpen} onOpenChange={setOpen}>
      <DialogContent className="!w-max min-w-[450px] !max-w-[calc(100vw-2rem)] md:!w-max">
        <DialogHeader>
          <DialogTitle>Invite to Workspace</DialogTitle>
        </DialogHeader>
        <CreateInviteForm
          onSuccess={() => {
            setOpen(false);
          }}
          workspace={userContext.activeWorkspace}
        />
      </DialogContent>
    </Dialog>
  );
};

export default AddWorkspaceMemberModal;
